import { atom } from "recoil";

export const userLoadingState = atom({
  key: "userLoading",
  default: true,
});
